import { useState, useEffect } from "react";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FcGoogle } from "react-icons/fc";
import { RegisterForm } from "../../api/api";
import Spinner from "../../Common/Spinner";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ImFacebook2 } from "react-icons/im";
import { BiLock } from "react-icons/bi";
import { handleApiError } from "../../Common/Helper";
const Register = () => {
  const [registerData, setRegisterData] = useState({
    email_update: "0", // Default value for email_update is 0
    inviter_affiliate_code: "", // Default value for inviter_affiliate_code
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Hook to access query parameters
  // Extract the inviter_affiliate_code from the query parameters
  useEffect(() => {
    const inviterAffiliateCode = searchParams.get("inviter_affiliate_code");
    console.log("inviterAffiliateCode =>", inviterAffiliateCode);
    if (inviterAffiliateCode) {
      setRegisterData((prevData) => ({
        ...prevData,
        inviter_affiliate_code: inviterAffiliateCode,
      }));
    }
  }, [searchParams]); // Re-run effect if searchParams changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRegisterData({
      ...registerData,
      [name]: type === "checkbox" ? (checked ? "1" : "0") : value, // Update email_update based on checkbox
    });
  };

  const validate = () => {
    const newErrors = {};
    // Email Validation
    if (!registerData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(registerData.email)) {
      newErrors.email = "Email is invalid";
    }
    // First Name Validation
    if (!registerData.first_name) {
      newErrors.first_name = "First name is required";
    }
    // Last Name Validation
    if (!registerData.last_name) {
      newErrors.last_name = "Last name is required";
    }
    // Password Validation
    if (!registerData.password) {
      newErrors.password = "Password is required";
    } else if (registerData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    // Confirm Password Validation
    if (!registerData.confirm_password) {
      newErrors.confirm_password = "Confirm password is required";
    } else if (registerData.confirm_password !== registerData.password) {
      newErrors.confirm_password = "Passwords do not match";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      const formData = new FormData();
      for (const key in registerData) {
        if (registerData.hasOwnProperty(key)) {
          formData.append(key, registerData[key]);
        }
      }
      console.log("formData ->", registerData);
      RegisterForm(formData)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            localStorage.setItem("willguru-token", JSON.stringify(res.data));
            setLoading(false);
            setTimeout(() => {
              navigate("/document");
            }, [2000]);
            toast.success("Account Created");
          } else {
            handleApiError(res, navigate); // Use helper function
            setLoading(false);
          }
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err);
        });
    }
  };

  return (
    <>
      <div className="bg-primary">
        <Toaster />
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black items-center">
            <div className="bg-[#fff] w-full mb-5 mx-auto px-[40px] py-[20px] h-auto rounded-lg">
              <h3 className="text-[20px] font-semibold ">
                Create your{" "}
                <span className="text-[#7a3db6] font-bold">WillGuru's</span>{" "}
                account
              </h3>
              <form onSubmit={handleSubmit}>
                <div className="my-5">
                  <FloatingLabelInput
                    label="Your First Name"
                    type="text"
                    id="first_name"
                    name="first_name"
                    value={registerData.first_name || ""}
                    error={errors.first_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="my-5">
                  <FloatingLabelInput
                    label="Your Last Name"
                    type="text"
                    id="last_name"
                    name="last_name"
                    value={registerData.last_name || ""}
                    error={errors.last_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="my-5">
                  <FloatingLabelInput
                    label="Email Address"
                    type="email"
                    id="email"
                    name="email"
                    value={registerData.email || ""}
                    error={errors.email}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <FloatingLabelInput
                    label="Password"
                    type="password"
                    id="password"
                    name="password"
                    value={registerData.password || ""}
                    error={errors.password}
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-5">
                  <FloatingLabelInput
                    label="Confirm Password"
                    type="password"
                    id="confirm_password"
                    name="confirm_password"
                    value={registerData.confirm_password || ""}
                    error={errors.confirm_password}
                    onChange={handleChange}
                  />
                </div>
                <div className="flex items-start my-5 mb-4">
                  <input
                    id="default-radio-1"
                    type="checkbox"
                    name="email_update"
                    className="w-5 h-5 mt-2 text-blue-600 bg-gray-100 border-gray-300"
                    onChange={handleChange}
                  />
                  <label htmlFor="default-radio-1" className="ms-2 text-[16px]">
                    Yes, Send me occasional useful emails with information and
                    discounts
                  </label>
                </div>
                <button
                  type="submit"
                  className="w-full py-3 mt-3 text-white font-bold bg-primary rounded d-flex justify-items-center"
                >
                  {loading ? <Spinner /> : "Create an Account"}
                </button>
              </form>
              <p className="text-center my-2">
                By creating an account you agree to our{" "}
                <a
                  className="underline font-semibold"
                  href="https://willsguru.com.au/terms-condition"
                >
                  terms and conditions
                </a>
              </p>
              <p className="text-center mb-2">
                Already have an account?{" "}
                <a href="/" className="underline font-semibold">
                  Log in
                </a>
              </p>
              <div className="my-[40px]">
                <div className="flex flex-col justify-center items-center">
                  <div className="w-[40px] h-[40px] text-[24px] flex items-center justify-center rounded-full bg-primary text-white">
                    <BiLock />
                  </div>
                  <div className="text-center">
                    <p className="font-bold text-[20px]">
                      Your data is safe with us
                    </p>
                    <p className="text-[14px] text-slate-500">
                      We use the very best in data security to make sure your
                      data are completely confidential - and we’ll never sell
                      your information.
                    </p>
                  </div>
                </div>
              </div>
              {/* <button className="w-full flex items-center hover:bg-primary hover:text-white transition-all ease-in justify-center gap-3 py-3 mt-3  font-bold bg-white text-[#240642] border-2 border-[#240642] rounded  ">
                <FcGoogle className="text-[26px]" />
                Sign In with Google
              </button>
              <button className="w-full flex items-center hover:bg-primary hover:text-white transition-all ease-in justify-center gap-3 py-3 mt-3  font-bold bg-white text-[#240642] border-2 border-[#240642] rounded  ">
                <ImFacebook2 className="text-[26px]" />
                Sign In with Facebbok
              </button> */}
            </div>
            <div className="max-lg:hidden">
              <div className="fixed bottom-0 2xl:w-[800px] lg:w-[500px] right-[6%] flex justify-center">
                <img
                  src="/assets/images/6.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
